import { render, staticRenderFns } from "./vipRecord.vue?vue&type=template&id=3776d662&scoped=true"
import script from "./vipRecord.vue?vue&type=script&lang=js"
export * from "./vipRecord.vue?vue&type=script&lang=js"
import style0 from "./vipRecord.vue?vue&type=style&index=0&id=3776d662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3776d662",
  null
  
)

export default component.exports